import React from "react"
import { cn } from "../styles/utils"
import { type PropsWithClassname } from "../types"
import { Pressable } from "./Pressable"

interface IconSwapButtonProps extends PropsWithClassname {
  defaultIcon: React.ReactNode
  hoverIcon: React.ReactNode
  onPress?: () => void
  hitSlop?: { top: number; bottom: number; left: number; right: number }
}

export const IconSwapButton: React.FC<IconSwapButtonProps> = ({
  defaultIcon,
  hoverIcon,
  onPress,
  hitSlop,
  className,
}) => {
  return (
    <Pressable
      onPress={onPress}
      className={cn(
        "p-1 rounded transition-colors duration-150 group hover:bg-background-100",
        className,
      )}
      hitSlop={hitSlop}
    >
      <div className="group-hover:hidden">{defaultIcon}</div>
      <div className="hidden group-hover:block">{hoverIcon}</div>
    </Pressable>
  )
}
